var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-container',{staticClass:"py-5"},[_c('h2',[_vm._v("Potwierdzenie zamówienia")]),(_vm.response)?_c('div',{staticClass:"mt-5",domProps:{"innerHTML":_vm._s(_vm.response)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }